"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../style/colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TitleContainer = exports.TitleContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__TitleContainer",
  componentId: "bufferapp-ui__sc-8p4a7u-0"
})(["display:flex;align-items:center;justify-content:space-between;padding-right:8px;padding-bottom:8px;border-bottom:1px solid ", ";"], _colors.grayLight);